import React, { useState, useEffect } from "react";
import { Link, NavLink } from 'react-router-dom';
import { Button, Image } from 'react-bulma-components';
import { Activity, Briefcase, ChevronsLeft, ChevronsRight, Grid, Mail, Settings, Trello, Users } from 'react-feather';

// actions
import { useAuthUser } from 'shared/state';

// images
import logo from 'shared/media/logo-thethrivers.png';
import logoMini from 'shared/media/logo-mini.png';

// styles
import styles from './navigation.module.scss';

const Navigation = () => {
    const { user } = useAuthUser();
    const [isOpened, setIsOpened] = useState(false);
    const [showNav, setShowNav] = useState(false);

    useEffect(() => {
        if( Object.keys(user).length > 0 ) {
            setShowNav(true);
        } else {
            setShowNav(false);
        }

    }, [user]);


    const handlePanel = () => {
        setIsOpened(!isOpened);
    }

    return (
        <nav role="navigation"
            aria-label="main navigation"
            className={ `${styles.nav} ${isOpened && styles['is-opened']}` }>
            { showNav &&
            <div className={ styles.innerNav }>
                <Link to="/" className={ styles.logoLink }>
                    { isOpened ?
                        <Image className={ styles.logo } src={ logo } /> :
                        <Image className={ styles['logo--mini'] } src={ logoMini } />
                    }
                </Link>

                <div className={ styles.mainMenu }>
                    <ul className="menu-list">
                        <li>
                            <NavLink to="/" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Grid size={25} strokeWidth={1.5} className={ styles.icon } />
                                <span>Dahsboard</span>
                            </NavLink>
                        </li>
                        { user.role !== 'member' &&
                        <li>
                            <NavLink to="/contacts" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Users size={25} strokeWidth={1.5} className={ styles.icon } />
                                <span>Contacts</span>
                            </NavLink>
                        </li>
                        }
                        { user.role === 'admin' &&
                        <li>
                            <NavLink to="/companies" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Briefcase size={25} strokeWidth={1.5} className={ styles.icon } />
                                <span>Companies</span>
                            </NavLink>
                        </li>
                        }
                        { user.role !== 'member' &&
                        <li>
                            <NavLink to="/leads" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Trello size={25} strokeWidth={1.5} className={ styles.icon } />
                                <span>Leads</span>
                            </NavLink>
                        </li>
                        }
                        { user.role !== 'member' &&
                        <li>
                            <NavLink to="/email" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Mail size={25} strokeWidth={1.5} className={ styles.icon } />
                                <span>Email</span>
                            </NavLink>
                        </li>
                        }
                        { user.role === 'admin' &&
                        <li>
                            <NavLink to="/financial" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Activity size={25} strokeWidth={1.5} className={ styles.icon } />
                                <span>Financial</span>
                            </NavLink>
                        </li>
                        }
                    </ul>

                    <ul className="menu-list">
                        { user.role === 'admin' &&
                        <li>
                            <NavLink to="/settings" className={({ isActive }) => (isActive ? 'is-active' : undefined)}>
                                <Settings size={25} strokeWidth={1.5} className={ styles.icon }/>
                                <span>Settings</span>
                            </NavLink>
                        </li>
                        }
                        <li>
                            <Button className={ styles.toggler } onClick={ handlePanel }>
                            { isOpened ?
                                <ChevronsLeft size={28} strokeWidth={1.5} className={ styles.icon } /> :
                                <ChevronsRight size={28} strokeWidth={1.5} className={ styles.icon } />
                            }
                            </Button>
                        </li>

                    </ul>
                </div>
            </div>
        }
        </nav>
    );
}

export default Navigation;
